import { useTranslation } from 'react-i18next'

export function EmptyState() {
  const { t } = useTranslation()
  return (
    <p className="quick-search__empty">
      {t('results-not-found')}
    </p>
  )
}
